// import { useNavigate } from 'react-router-dom';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
// import MDAlert from "components/MDAlert";
import MDButton from 'components/MDButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Oval } from 'react-loader-spinner';
import MDInput from "components/MDInput";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Radio } from '@mui/material';
import * as moment from 'moment';
import Select from 'react-select';
import * as service from '../../services/service';

function LRDetails() {
    const [state, setState] = useState({ lrno: '', gst: '', freight: '', ewaybillno: '', vehicleno: '', });
    const [lrDate, setLRDate] = useState(new Date());
    const [data, setData] = useState([]);
    const [supplierId, setSupplierId] = useState('');
    const [supplierData, setSupplierData] = useState([]);
    const [invoiceId, setInvoiceId] = useState('');
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };
    const userDesignation = JSON.parse(sessionStorage.getItem('userData')).designation;
    const getDetails = () => {
        fetch(
            service.GET_INVOICES_FOR_LR,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                setData(result);
            })
            .catch(err => {
                if (err) {
                    setErrors(err);
                };
            });
    };

    // const getWODetailsById = (id) => {
    //     setLoading(true);
    //     const errs = {};
    //     fetch(
    //         service.GET_WORK_ORDER_BY_ID,
    //         {
    //             method: 'POST',
    //             headers: {
    //                 'Accept': 'application/json',
    //                 'Content-Type': 'application/json'
    //             },
    //             body: JSON.stringify({
    //                 WorkOrderId: id,
    //             })
    //         })
    //         .then(res => res.json())
    //         .then(result => {
    //             if (result.message.messageType === 'Success') {
    //                 setWorkOrderData(result);
    //             }
    //             else {
    //                 errs[".invalid"] = result.message.message;
    //                 setErrors(errs);
    //             }
    //         });

    //     setLoading(false);
    // };

    // const getNextLRNo = () => {
    //     fetch(
    //         service.GET_NEXT_LR_NO,
    //         {
    //             method: 'POST',
    //             headers: {
    //                 'Accept': 'application/json',
    //                 'Content-Type': 'application/json'
    //             },
    //         })
    //         .then(res => res.json())
    //         .then(result => {
    //             setState({ ...state, lrno: result.lrNo });
    //         });
    // };
    const getSuppliers = () => {
        fetch(
            service.SUPPLIER_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({

                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.supplierId, label: item.supplierName }));
                setSupplierData(data2);
            });
    };

    const validate = () => {
        let isValid = true;
        const errs = {};
        if (!invoiceId) {
            isValid = false;
            errs[".invoiceId"] = "Please select invoice";
        }
        if (!state.lrno) {
            isValid = false;
            errs[".lrno"] = "Please enter LR No.";
        }
        if (!lrDate) {
            isValid = false;
            errs[".lrDate"] = "Please enter LR date";
        }
        if (!state.freight) {
            isValid = false;
            errs[".freight"] = "Please enter freight";
        }
        if (!state.gst) {
            isValid = false;
            errs[".gst"] = "Please enter gst";
        }
        if (!state.vehicleno) {
            isValid = false;
            errs[".vehicleno"] = "Please enter vehicleno";
        }
        setErrors(errs);
        return isValid;
    }

    const submitHandler = e => {
        if (validate()) {
            e.preventDefault();
            const errs = {};
            setLoading(true);
            fetch(
                service.ADD_LR,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        LRNo: state.lrno,
                        LRDate: moment(lrDate).format("MM/DD/YYYY"),
                        InvoiceId: invoiceId,
                        eWayBillNo: state.ewaybillno,
                        SupplierId: supplierId ? supplierId.value : 0,
                        Freight: state.freight,
                        GST: state.gst,
                        VehicleNo: state.vehicleno,
                        AddedBy: JSON.parse(sessionStorage.getItem('userData')).employeeId,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.messageType === 'Success') {
                        // eslint-disable-next-line
                        alert(result.message);
                        window.location.reload(false);
                    }
                    else if (result.messageType === 'Failed') {
                        // eslint-disable-next-line
                        alert(result.message);
                        // navigate('/customer/workorder');
                    }
                    else {
                        errs[".invalid"] = result.message.message;
                        setErrors(errs);
                    }
                });
            setLoading(false);
        }
    }

    useEffect(() => {
        setLoading(true);
        // getNextLRNo();
        getSuppliers();
        getDetails();
        setLoading(false);
    }, []);

    const changeHandler = (event) => {
        if (event.target.name === 'freight') {
            if (Number.isNaN(parseFloat(event.target.value))) {
                // eslint-disable-next-line
                alert("Please enter numbers only");
                event.target.value = ""; // eslint-disable-line no-param-reassign
            }
        }
        if (event.target.name === 'gst') {
            if (Number.isNaN(parseFloat(event.target.value))) {
                // eslint-disable-next-line
                alert("Please enter numbers only");
                event.target.value = ""; // eslint-disable-line no-param-reassign
            }
        }
        setState({ ...state, [event.target.name]: event.target.value });
    };

    const handleRadioChange = (invId) => {
        setInvoiceId(invId);
        // getWODetailsById(woId);
    }
    const supplierChangeHandler = (ev) => {
        setSupplierId(ev);
    }
    // const clearHandler = () => {
    //     setDeliveryChallanId('');
    //     setData([]);
    // }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    LR Details
                                </MDTypography>
                            </MDBox>
                            <br />
                            <Card style={{ alignItems: 'center' }}>
                                {loading ? <Oval
                                    heigth="100"
                                    width="100"
                                    color='grey'
                                    ariaLabel='loading'
                                /> :
                                    <TableContainer component={Paper} style={{ width: '90%', alignSelf: 'center', }}>
                                        <Table aria-label="simple table">
                                            <TableRow>
                                                <TableCell style={{ fontWeight: 'bold' }}>Select</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Invoice No</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Customer</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Job No</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Product</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Sub Assembly</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Part</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Quantity in DL</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Shipping Address</TableCell>
                                            </TableRow>
                                            <TableBody>
                                                {data.map((row) => (
                                                    <TableRow
                                                        key={row.invoiceId}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell>
                                                            <Radio onChange={() => handleRadioChange(row.invoiceId)}
                                                                value={row.invoiceId} name="radio-buttons"
                                                                checked={invoiceId === row.invoiceId} />
                                                        </TableCell>
                                                        <TableCell>{row.invoiceNo}</TableCell>
                                                        <TableCell>{row.customerName}</TableCell>
                                                        <TableCell>{row.jobNo}</TableCell>
                                                        <TableCell>{row.product}</TableCell>
                                                        <TableCell>{row.subAssembly}</TableCell>
                                                        <TableCell>{row.part}</TableCell>
                                                        <TableCell>{row.challanQuantity}</TableCell>
                                                        <TableCell>{row.shippingAddress}</TableCell>
                                                    </TableRow>
                                                ))}
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invoiceId"]}</div>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }
                                {/* <br />
                                {workOrderData ?
                                    <TableContainer component={Paper} style={{ width: '90%', alignSelf: 'center', }}>
                                        <Table aria-label="simple table">
                                            <TableRow>
                                                <TableCell style={{ fontWeight: 'bold' }} colSpan="9" align="center">
                                                    Work Order Details
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{ fontWeight: 'bold' }}>Work Order No.</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Job No.</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Product Category</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Product Sub Category</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Product</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Sub Assembly</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Part</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Quantity</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Total Amount</TableCell>
                                            </TableRow>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell component="th" scope="row">{workOrderData.workOrderNo}</TableCell>
                                                    <TableCell component="th" scope="row">{workOrderData.jobNo}</TableCell>
                                                    <TableCell component="th" scope="row">{workOrderData.productCategory}</TableCell>
                                                    <TableCell component="th" scope="row">{workOrderData.productSubCategory}</TableCell>
                                                    <TableCell component="th" scope="row">{workOrderData.product}</TableCell>
                                                    <TableCell component="th" scope="row">{workOrderData.subAssembly}</TableCell>
                                                    <TableCell component="th" scope="row">{workOrderData.part}</TableCell>
                                                    <TableCell component="th" scope="row">{workOrderData.quantity}</TableCell>
                                                    <TableCell component="th" scope="row">{workOrderData.totalAmount}</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    : null} */}
                                <br />
                                <TableContainer component={Paper} style={{ width: '90%', alignSelf: 'center', }}>
                                    <Table aria-label="simple table">
                                        <TableRow>
                                            <TableCell width="35%">
                                                <MDInput label="LR No." fullWidth value={state.lrno || ''}
                                                    name="lrno"
                                                    onChange={changeHandler}
                                                    id="lrno"
                                                    required
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".lrno"]}</div>
                                            </TableCell>
                                            <TableCell width="35%">
                                                LR Date
                                                <DatePicker
                                                    id="lrDate"
                                                    selected={lrDate}
                                                    onChange={date => setLRDate(date)}
                                                    dateFormat="MM/dd/yyyy"
                                                    tabIndex={0}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".lrDate"]}</div>
                                            </TableCell>
                                            <TableCell style={{ fontSize: '12px' }}>
                                                <Select
                                                    options={supplierData}
                                                    name="supplier"
                                                    value={supplierId}
                                                    onChange={supplierChangeHandler}
                                                    placeholder="Select Supplier"
                                                    isSearchable
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".supplierId"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <MDInput label="eWay Bill No" fullWidth value={state.ewaybillno || ''}
                                                    name="ewaybillno"
                                                    onChange={changeHandler}
                                                    id="ewaybillno"
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".ewaybillno"]}</div>
                                            </TableCell>
                                            <TableCell>
                                                <MDInput label="Freight" fullWidth value={state.freight || ''}
                                                    name="freight"
                                                    onChange={changeHandler}
                                                    id="freight"
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".freight"]}</div>
                                            </TableCell>
                                            <TableCell>
                                                <MDInput label="GST" fullWidth value={state.gst || ''}
                                                    name="gst"
                                                    onChange={changeHandler}
                                                    id="gst"
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".gst"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <MDInput label="Vehicle No." fullWidth value={state.vehicleno || ''}
                                                    name="vehicleno"
                                                    onChange={changeHandler}
                                                    id="vehicleno"
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".vehicleno"]}</div>
                                            </TableCell>
                                        </TableRow>
                                    </Table>
                                </TableContainer>
                                {userDesignation === 'General Manager' || userDesignation === 'Asst Mgr - Store'
                                    || userDesignation === 'Jr Mgr - Store' || userDesignation === 'Manager - Store'
                                    || userDesignation === 'Sr Mgr - Store' || userDesignation === 'Asst Mgr - Marketing'
                                    || userDesignation === 'Jr Mgr - Marketing' || userDesignation === 'Manager - Marketing'
                                    || userDesignation === 'Sr Mgr - Marketing' || userDesignation === 'MD' 
                                    || userDesignation === 'Assistant - Marketing' || userDesignation === 'Assistant - Store' ?
                                    <MDBox mt={4} mb={1} textAlign="center">
                                        {loading ? <Oval
                                            heigth="20"
                                            width="20"
                                            color='grey'
                                            ariaLabel='loading'
                                        /> :
                                            <div>
                                                <MDButton color="info" onClick={submitHandler}>
                                                    SAVE
                                                </MDButton>
                                            </div>
                                        }
                                        {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                    </MDBox>
                                    : null}
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0 }}>
                <Footer />
            </div>
        </DashboardLayout>
    );
}
export default LRDetails;